module.exports = __webpack_public_path__ + "static/media/korg.15e5ea6c.svg";